module.exports = __webpack_public_path__ + "static/media/icon-chevrondown.5d4d9d41.svg";